
import './styles.css';
import CardHeader from "../../../antd/components/CardHeader";
import { useParams } from "react-router-dom";
import PLeaScheduleForm from "../../../antd/components/Plea/PleaSchedule/Form";
import { CreatePleaSchedule, DeletePleaScheduleById, DownloadPleaScheduleByPleaId, EditPleaSchedule, GetPleaScheduleByPleaId } from "../../../API/PleaSchedule";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import useLoading from "../../../Hooks/useLoading";
import { useToast } from "../../../antd/hooks/toast";
import { useEffect, useState } from "react";
import { Button, Progress, Typography } from "antd";
import { CloudDownloadOutlined, FilterOutlined, PlusOutlined, QuestionCircleOutlined, SearchOutlined, SortAscendingOutlined } from "@ant-design/icons";
import { Filter1Outlined } from '@mui/icons-material';
import { PleaScheduleModel } from '../../../Models/PleaScheduleModel';
import PLeaScheduleTable from '../../../antd/components/Plea/PleaSchedule/Table';
import { PleaModel } from '../../../Models/PleaModel';
import { GetPleaByPleaId } from '../../../API/PleaAPI';
import { set } from 'react-hook-form';
import Modal from 'antd/es/modal/Modal';
import ModalPleaScheduleInfo from '../../../antd/components/Plea/PleaSchedule/Modal';

export default function PleaSchedule() {
    const { id, pleaId } = useParams();
    const { loading, toggleLoading } = useLoading();
    const [ isFormVisible, setFormVisible ] = useState(false);
    const  toast  = useToast();
    const [ plea, setPlea ] = useState<PleaModel>();
    const [ pleaScheduleList, setPleaScheduleList ] = useState<PleaScheduleModel[]>([]);
    const [ itemEdit, setItemEdit ] = useState<PleaScheduleModel>();
    const [ infoOpen, setInfoOpen] = useState(false);

    const GetPlea = async () => {
        try {
            if (pleaId) {
                await GetPleaByPleaId(pleaId).then((resp: IResponseProps) => {
                    if (resp.statusCode == 200) {
                        setPlea(resp.data);
                    }
                }).finally(() => {
                    toggleLoading(false);
                });
            }
        } catch (error: any) {
            toast.error({ message: 'Erro ao consultar dados!' });
            toggleLoading(false);
        }
    };
    const GetPleaSchedule= async () => {
        try {
            if (pleaId) {
                await GetPleaScheduleByPleaId(pleaId).then((resp: IResponseProps) => {
                    if (resp.statusCode == 200) {
                        setPleaScheduleList(resp.data);
                    }
                }).finally(() => {
                    toggleLoading(false);
                });
            }
        } catch (error: any) {
            toast.error({ message: 'Erro ao consultar dados!' });
            toggleLoading(false);
        }
    };

    const CreateSchedule = async (values: PleaScheduleModel) => {

        if (pleaId) {
            try {
                toggleLoading(true);

                const response = await CreatePleaSchedule(
                    values.name,
                    values.details,
                    values.physicalIndicator,
                    values.startDate,
                    values.endDate,
                    values.startMonth,
                    values.duration,
                    values.finepDuration,
                    pleaId
                ).then((resp: IResponseProps) => {
                    if (resp.statusCode == 200) {
                        toast.success({ message: `Dados atualizados com sucesso!` });
                    }
                })
                    .finally(() => {
                        GetPleaSchedule();
                        toggleLoading(false);
                    });
            } catch (error: any) {
                toast.error({ message: 'Erro ao inserir dados!' });
            }
        }
        else{
            toast.error({ message: 'Erro ao acessar o pleito!' });
        }
    };

    const EditSchedule = async (values: PleaScheduleModel) => {

        if (pleaId) {
            try {
                toggleLoading(true);

                const response = await EditPleaSchedule(
                    values.id,
                    values.name,
                    values.details,
                    values.physicalIndicator,
                    values.startDate,
                    values.endDate,
                    values.startMonth,
                    values.duration,
                    values.finepDuration,
                    pleaId
                ).then((resp: IResponseProps) => {
                    if (resp.statusCode == 200) {
                        toast.success({ message: `Dados atualizados com sucesso!` });
                    }
                })
                    .finally(() => {
                        GetPleaSchedule();
                        setItemEdit(undefined);
                        toggleLoading(false);
                    });
            } catch (error: any) {
                toast.error({ message: 'Erro ao inserir dados!' });
            }
        }
        else{
            toast.error({ message: 'Erro ao acessar o pleito!' });
        }
    };

    const DeletePleaSchedule = async (id: string) => {
        try {
            await DeletePleaScheduleById(id).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    toast.success({ message: `Dados excluídos com sucesso!` });
                }
            }).finally(() => {
                toggleLoading(false);
                GetPleaSchedule();
                setItemEdit(undefined);
                setFormVisible(false);
            });
        } catch (error: any) {
            toast.error({ message: 'Erro ao consultar dados!' });
            toggleLoading(false);
        }
    };

    const DownloadSchedule = async (pleaId: string) => {
        try {
            toggleLoading(true);
            await DownloadPleaScheduleByPleaId(pleaId).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Cornograma Pleito ${plea?.bankName} ${plea?.version}.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
    
                if (response.statusCode === 200) {
                    toast.success({ message: `Cronograma baixado com sucesso!` });
                }
            });
        }
        catch (err: any) {
            toast.error(err);
        }
        finally {
            toggleLoading(false);
        }
    
    }

    const handleSetFormOpen = () => {
        if(itemEdit) {
            setItemEdit(undefined);
        }
        else {
            setFormVisible(!isFormVisible);
        }

    }

    useEffect(() => {
        GetPleaSchedule();
        GetPlea();
    }
    , [pleaId]);

    useEffect(() => {
        if (itemEdit) {
            setFormVisible(true);
        }
    }, [itemEdit]);

    return (
        <div className='card' style={{ margin: '10px' }}>
            <CardHeader
                pageName={"Cronograma Técnico " + plea?.version + " - " + plea?.bankName}
                hasPageBefore={true}
                pageBeforeName={'Cadastro'}
                linkPageBefore={`/plea/financial/finep/${id}/${pleaId}`}
            />
            <ModalPleaScheduleInfo show={infoOpen} toggleShow={() => setInfoOpen(!infoOpen)} />
            <div className='main-container'>
                <div className='button-header'>
                    <div className='button-noBorder-container'>                       
                        <Button className='button-black' size='large' type='text' onClick={() => setInfoOpen(!infoOpen)}>
                            <QuestionCircleOutlined />
                        </Button>
                    </div>
                    <div className='button-border-container'>
                        <Button className='button-blue' size="large" onClick={() => {DownloadSchedule(pleaId ? pleaId : '')}}>
                            <CloudDownloadOutlined/>
                            <Typography className='text-blue'>Extrair Cronograma</Typography>
                        </Button>
                        <Button size="large" type="primary" onClick={() => handleSetFormOpen()}>
                            <PlusOutlined />
                            Nova Atividade
                        </Button>
                    </div>
                    
                </div>
                {
                    isFormVisible && (
                        <PLeaScheduleForm operationCreate={CreateSchedule} operationEdit={EditSchedule} itemEdit={itemEdit} isOpen={setFormVisible}  />
                )}

                <div className='div-schedule'>
                    <div className='div-table'>
                        <PLeaScheduleTable items={pleaScheduleList} operationDelete={DeletePleaSchedule} setItemEdit={setItemEdit} />
                    </div>

                </div>
            </div>
        </div>
    );
}